import { render, staticRenderFns } from "./dish-detail.vue?vue&type=template&id=59c32d02&scoped=true&"
import script from "./dish-detail.vue?vue&type=script&lang=js&"
export * from "./dish-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c32d02",
  null
  
)

export default component.exports